import { c as _c } from "react/compiler-runtime";
import { useMemo } from 'react';
import type { TweetSummarySectionItem } from '../types';
import { formatCount } from '../utils';
export interface EngagementSummaryResult {
  engagementRate: number | null;
  items: TweetSummarySectionItem[];
  totalEngagements: number;
}
export function useEngagementSummary(metrics) {
  const $ = _c(35);
  const likeCount = metrics.likeCount ?? 0;
  const retweetCount = metrics.retweetCount ?? 0;
  const replyCount = metrics.replyCount ?? 0;
  const quoteCount = metrics.quoteCount ?? 0;
  const bookmarkCount = metrics.bookmarkCount ?? 0;
  const impressionCount = metrics.impressionCount ?? null;
  const totalEngagements = likeCount + retweetCount + replyCount + quoteCount + bookmarkCount;
  const engagementRate = impressionCount && impressionCount > 0 ? totalEngagements / impressionCount : null;
  let t0;
  if ($[0] !== likeCount) {
    t0 = formatCount(likeCount);
    $[0] = likeCount;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = {
      label: "Likes",
      value: t0
    };
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== retweetCount) {
    t2 = formatCount(retweetCount);
    $[4] = retweetCount;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t2) {
    t3 = {
      label: "Reposts",
      value: t2
    };
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== replyCount) {
    t4 = formatCount(replyCount);
    $[8] = replyCount;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t4) {
    t5 = {
      label: "Replies",
      value: t4
    };
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== quoteCount) {
    t6 = formatCount(quoteCount);
    $[12] = quoteCount;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t6) {
    t7 = {
      label: "Quotes",
      value: t6
    };
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let items;
  if ($[16] !== bookmarkCount || $[17] !== impressionCount || $[18] !== t1 || $[19] !== t3 || $[20] !== t5 || $[21] !== t7) {
    items = [t1, t3, t5, t7];
    if (bookmarkCount > 0) {
      let t8;
      if ($[23] !== bookmarkCount) {
        t8 = formatCount(bookmarkCount);
        $[23] = bookmarkCount;
        $[24] = t8;
      } else {
        t8 = $[24];
      }
      let t9;
      if ($[25] !== t8) {
        t9 = {
          label: "Bookmarks",
          value: t8
        };
        $[25] = t8;
        $[26] = t9;
      } else {
        t9 = $[26];
      }
      items.push(t9);
    }
    if (typeof impressionCount === "number" && impressionCount > 0) {
      let t8;
      if ($[27] !== impressionCount) {
        t8 = formatCount(impressionCount);
        $[27] = impressionCount;
        $[28] = t8;
      } else {
        t8 = $[28];
      }
      let t9;
      if ($[29] !== t8) {
        t9 = {
          label: "Impressions",
          value: t8,
          emphasis: "muted"
        };
        $[29] = t8;
        $[30] = t9;
      } else {
        t9 = $[30];
      }
      items.push(t9);
    }
    $[16] = bookmarkCount;
    $[17] = impressionCount;
    $[18] = t1;
    $[19] = t3;
    $[20] = t5;
    $[21] = t7;
    $[22] = items;
  } else {
    items = $[22];
  }
  let t8;
  if ($[31] !== engagementRate || $[32] !== items || $[33] !== totalEngagements) {
    t8 = {
      items,
      totalEngagements,
      engagementRate
    };
    $[31] = engagementRate;
    $[32] = items;
    $[33] = totalEngagements;
    $[34] = t8;
  } else {
    t8 = $[34];
  }
  return t8 satisfies EngagementSummaryResult;
}